import React from 'react';

import { TableView as TableViewIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { CompanyType } from 'src/api';
import { DetailPageLayout } from 'src/components/common';
import { PeoPayrollProvidersDetailsWallet } from 'src/components/peoPayrollProvider';
import { ModalId } from 'src/constants/modals';
import { usePeoPayrollProviderParamId } from 'src/hooks/peoPayrollProvider';
import { useModalV2 } from 'src/hooks/shared';
import { RevenueShareReportGeneratingModal } from 'src/modals/billing';

export const PeoPayrollProviderDetailBillingPage: React.FC = () => {
  const peoPayrollProviderId = usePeoPayrollProviderParamId();
  const { openModal } = useModalV2();

  const handleRevenueShareReportClick = React.useCallback(() => {
    openModal(RevenueShareReportGeneratingModal, {
      id: ModalId.RevenueShareReportGenerating,
      companyId: peoPayrollProviderId,
      companyType: CompanyType.PeoPayrollProvider,
    });
  }, [peoPayrollProviderId, openModal]);

  return (
    <DetailPageLayout
      titleContent="Billing"
      topRightContent={
        <Button
          variant="contained"
          size="small"
          onClick={handleRevenueShareReportClick}
          startIcon={<TableViewIcon />}
        >
          Generate report
        </Button>
      }
    >
      <PeoPayrollProvidersDetailsWallet />
    </DetailPageLayout>
  );
};
